var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"更新图片","visible":_vm.showBlock,"destroy-on-close":true,"width":"600px","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.showBlock=$event}}},[_c('UpLoadImng',{attrs:{"width":"76","height":"76","size":"1","limit":"5","rules":"gif、png"},on:{"getUpload":_vm.getUpload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }